import React, { Fragment } from 'react';

import styles from './userSavedSearchesPageStyles';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

const DeletedFundSavedSearches = ({
  deletedSearches,
  handleRestoreSearchAlert,
  removeFromSoftDelete
}) => (
  <Fragment>
    {Object.keys(deletedSearches).map(alertId => {
      const alert = deletedSearches[alertId];
      return (
        <div key={alertId} className={styles.deleteMessage}>
          Search "{alert.name}" deleted successfully.
          <strong className={styles.undoButton} onClick={() => handleRestoreSearchAlert(alert)}>
            Undo
          </strong>
          <XMarkIcon
            className={styles.removeIcon}
            onClick={() => {
              delete deletedSearches[`${alertId}`];
              removeFromSoftDelete(deletedSearches, alertId);
            }}
          />
        </div>
      );
    })}
  </Fragment>
);

export default DeletedFundSavedSearches;
